import { useParams } from 'react-router-dom';

const useWorkspaceId = (): string => {
  const params = useParams();
  if (!params.workspace_id) throw new Error('Workspace ID is required');
  return params.workspace_id;
};

export default useWorkspaceId;
